import React from 'react'
import { makeStyles } from '@material-ui/core'
import GlueButton from './glue-button'

const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    ...theme.custom.errorDialog.root,
    width: props.width ? props.width : null
  }),

  image: theme.custom.errorDialog.image,

  header: {
    ...theme.custom.errorDialog.header,
    display: 'flex',
    padding: `0 ${theme.spacing('l')}`,
    marginBottom: theme.spacing('m'),
    '&> *:first-child': {
      margin: 'auto'
    }
  },

  body: {
    ...theme.custom.errorDialog.body,
    padding: `0 ${theme.spacing('l')}`,
    margin: `${theme.spacing('xl')} 0`
  },

  buttons: {
    ...theme.custom.errorDialog.buttons,
    gap: theme.spacing('m')
  }

}))

const GeneralDialogTemplate = (props) => {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <h2>{props.header}</h2>
      </div>
      {props.image && <img className={classes.image} src={props.image} alt={''} />}
      <div className={classes.body}>
        {props.body}
      </div>
      <div className={classes.buttons}>
        {props.callbacks ? props.callbacks.map((btn, i) => (
          <GlueButton key={i}
            onPointerDown={() => { btn.callback(); props.onCloseDialog() }}
            color={btn.color ? btn.color : null} >
            {btn.label ? btn.label : 'Submit'}
          </GlueButton>))
          : <GlueButton color='primary' onPointerDown={props.onCloseDialog}>OK</GlueButton>}
      </div>
    </div>
  )
}

export default GeneralDialogTemplate
